var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    id: "folders",
    class: "mt-0"
};
const _hoisted_2 = { class: "grid col-span-3 gap-6 container-folders sm:grid-cols-2 md:grid-cols-5 sm:gap-y-5 lg:gap-x-8" };
import { Edit01Icon, Trash01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UITextSmMedium, renderIcon } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
import { VueDraggableNext as draggable } from 'vue-draggable-next';
import { useI18n } from 'vue-i18n';
import ContextMenu from '../components/ContextMenu.vue';
import FolderComponent from '../components/FolderComponent.vue';
import useContextMenu from '../composable/useContextMenu';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FoldersView',
    props: {
        folders: {},
        category: {},
        mediaLayout: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const { sendNotification } = useEvent();
        const emitter = useEmitter();
        const { $state, updateActiveObject, updateDirectory } = useStore();
        const { contextMenuItemClick } = useContextMenu();
        const activeItem = computed(() => { var _a; return ((_a = $state === null || $state === void 0 ? void 0 : $state.activeItem) === null || _a === void 0 ? void 0 : _a._id) || false; });
        const contextMenuItems = [
            {
                name: t('common.rename'),
                slug: 'rename',
                icon() {
                    return renderIcon(Edit01Icon);
                },
            },
            {
                name: t('common.delete'),
                slug: 'delete',
                icon() {
                    return renderIcon(Trash01Icon);
                },
            },
        ];
        function onClickFolder(folder) {
            updateActiveObject('');
            updateDirectory(folder);
        }
        function onSelectFolder(folder) {
            updateActiveObject(folder);
            emitter.emit('media-select-option', {
                file: folder,
                fileType: 'folder',
            });
        }
        const contextMenuRef = ref();
        function handleFolderRightClick(event, item) {
            contextMenuRef.value.showMenu(event, item);
        }
        function moveFile(folder, evt) {
            return __awaiter(this, void 0, void 0, function* () {
                const targetParentId = folder._id || '';
                const file = evt.added.element;
                const fileId = file._id;
                const altId = $state.altId;
                const altType = $state.altType;
                yield MediaService.moveFile({
                    fileId,
                    altId,
                    altType,
                    targetParentId,
                });
                emitter.emit('updateUI');
                sendNotification({
                    duration: 5000,
                    type: 'success',
                    title: t('common.successfullyMovedFile'),
                });
            });
        }
        function dragOver(event) {
            event.target.classList.add('active-folder');
        }
        function dragLeave(event) {
            event.target.classList.remove('active-folder');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.folders.length > 0 && (_ctx.mediaLayout === 'grid' || _ctx.category === 'all'))
                    ? (_openBlock(), _createBlock(_unref(UITextSmMedium), {
                        key: 0,
                        class: "pb-2 text-gray-600"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.folders')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder, index) => {
                        return (_openBlock(), _createBlock(_unref(draggable), {
                            key: index,
                            list: [folder],
                            sort: false,
                            onChange: ($event) => (moveFile(folder, $event)),
                            group: { name: 'files', pull: false },
                            class: "w-full dragArea list-group folder-drag-area",
                            dragoverBubble: true,
                            handle: '.'
                        }, {
                            default: _withCtx(() => [
                                _createVNode(FolderComponent, {
                                    id: folder._id,
                                    folder: folder,
                                    onDblclick: ($event) => (onClickFolder(folder)),
                                    onClick: ($event) => (onSelectFolder(folder)),
                                    activeItem: activeItem.value,
                                    onDragover: dragOver,
                                    onDragleave: dragLeave,
                                    onContextmenu: _withModifiers(($event) => (handleFolderRightClick($event, folder)), ["prevent", "stop"])
                                }, null, 8, ["id", "folder", "onDblclick", "onClick", "activeItem", "onContextmenu"])
                            ]),
                            _: 2
                        }, 1032, ["list", "onChange"]));
                    }), 128)),
                    _createVNode(ContextMenu, {
                        elementId: 'folderMenu',
                        options: contextMenuItems,
                        ref_key: "contextMenuRef",
                        ref: contextMenuRef,
                        onOptionClicked: _unref(contextMenuItemClick)
                    }, null, 8, ["onOptionClicked"])
                ])
            ]));
        };
    }
});
